// extracted by mini-css-extract-plugin
export default {"removeBoundaryBtn":"styles_removeBoundaryBtn__VG7P+","closeIcon":"styles_closeIcon__LvOtb"};